"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sendTypingIndicator;

var _setSendTypingIndicator = require("../actions/setSendTypingIndicator");

var DEFAULT_STATE = false;

function sendTypingIndicator() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      payload = _ref.payload,
      type = _ref.type;

  switch (type) {
    case _setSendTypingIndicator.SET_SEND_TYPING_INDICATOR:
      state = payload.sendTypingIndicator;
      break;

    default:
      break;
  }

  return state;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZWR1Y2Vycy9zZW5kVHlwaW5nSW5kaWNhdG9yLmpzIl0sIm5hbWVzIjpbIkRFRkFVTFRfU1RBVEUiLCJzZW5kVHlwaW5nSW5kaWNhdG9yIiwic3RhdGUiLCJwYXlsb2FkIiwidHlwZSIsIlNFVF9TRU5EX1RZUElOR19JTkRJQ0FUT1IiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7QUFFQSxJQUFNQSxhQUFhLEdBQUcsS0FBdEI7O0FBRWUsU0FBU0MsbUJBQVQsR0FBdUU7QUFBQSxNQUExQ0MsS0FBMEMsdUVBQWxDRixhQUFrQzs7QUFBQTtBQUFBLE1BQWpCRyxPQUFpQixRQUFqQkEsT0FBaUI7QUFBQSxNQUFSQyxJQUFRLFFBQVJBLElBQVE7O0FBQ3BGLFVBQVFBLElBQVI7QUFDRSxTQUFLQyxpREFBTDtBQUNFSCxNQUFBQSxLQUFLLEdBQUdDLE9BQU8sQ0FBQ0YsbUJBQWhCO0FBQ0E7O0FBRUY7QUFDRTtBQU5KOztBQVNBLFNBQU9DLEtBQVA7QUFDRCIsInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFNFVF9TRU5EX1RZUElOR19JTkRJQ0FUT1IgfSBmcm9tICcuLi9hY3Rpb25zL3NldFNlbmRUeXBpbmdJbmRpY2F0b3InO1xuXG5jb25zdCBERUZBVUxUX1NUQVRFID0gZmFsc2U7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHNlbmRUeXBpbmdJbmRpY2F0b3Ioc3RhdGUgPSBERUZBVUxUX1NUQVRFLCB7IHBheWxvYWQsIHR5cGUgfSkge1xuICBzd2l0Y2ggKHR5cGUpIHtcbiAgICBjYXNlIFNFVF9TRU5EX1RZUElOR19JTkRJQ0FUT1I6XG4gICAgICBzdGF0ZSA9IHBheWxvYWQuc2VuZFR5cGluZ0luZGljYXRvcjtcbiAgICAgIGJyZWFrO1xuXG4gICAgZGVmYXVsdDpcbiAgICAgIGJyZWFrO1xuICB9XG5cbiAgcmV0dXJuIHN0YXRlO1xufVxuIl19